<template>
    <div>
        <Card v-if="selectedTree.s.snameArr.length>0 || selectedTree.c.snameArr.length>0
                    || selectedTree.g.snameArr.length>0 || selectedTree.u.snameArr.length>0"
              :style="{textAlign:'left',fontSize:'14px',fontWeight:'bold'}">
            <Row v-if="selectedTree.s.snameArr.length>0">
                <Col span="24">
                    <div>
                        {{lang('selectedScopeText_s',language)}}：
                        {{selectedTree.s.snameArr.toString()}}
                    </div>
                </Col>
            </Row>
            <Row v-if="selectedTree.c.snameArr.length>0">
                <Col span="24">
                    <div>
                        {{lang('selectedScopeText_c',language)}}：
                        {{selectedTree.c.snameArr.toString()}}
                    </div>
                </Col>
            </Row>
            <Row v-if="selectedTree.g.snameArr.length>0">
                <Col span="24">
                    <div>
                        {{lang('selectedScopeText_g',language)}}：
                        {{selectedTree.g.snameArr.toString()}}
                    </div>
                </Col>
            </Row>
            <Row v-if="selectedTree.u.snameArr.length>0">
                <Col span="24">
                    <div>
                        {{lang('selectedScopeText_u',language)}}：
                        {{selectedTree.u.snameArr.toString()}}
                    </div>
                </Col>
            </Row>
        </Card>
        <Card>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('groupDataText',language)}}
            </p>
            <Row>
                <Col span="4">
                    <p :style="{textAlign:'left',fontSize:'16px',fontWeight:'bold',marginTop:'5px'}">
                        {{lang('selectDataTypeText',language)}}：</p>
                </Col>
                <Col span="16" >
                    <div :style="{textAlign:'left'}">
                        <RadioGroup v-model="scopeType" type="button" @on-change="changeScopeType">
                            <Radio label="s" v-if="userInfo !== null && userInfo.adminRole !== 3">{{lang('scopeType_s',language)}}</Radio>
                            <Radio label="c" >{{lang('scopeType_c',language)}}</Radio>
                            <Radio label="g">{{lang('scopeType_g',language)}}</Radio>
                            <Radio label="u">{{lang('scopeType_u',language)}}</Radio>
                        </RadioGroup>
                    </div>
                </Col>
            </Row>
            <br>
            <Row>
                <Col span="4">
                    <p :style="{textAlign:'left',fontSize:'16px',fontWeight:'bold',marginTop:'5px'}">
                        {{lang('selectText',language)}}{{lang('scopeType_'+currentScopeType,language)}}：
                    </p>
                </Col>
                <Col span="11">
                    <Input v-model="keywords" clearable style="width: 400px"/>
                </Col>
                <Col span="5">
                    <Button type="primary" @click="search">
                        <Icon type="ios-search" />
                        {{lang('seachText',language)}}
                    </Button>
                </Col>
            </Row>
            <br>
            <Row>
                <Col span="24">
                    <div :style="{textAlign:'left'}" v-if="selectedTree[currentScopeType].scopeType != scopeType">
                        <RadioGroup v-model="selectedTree[currentScopeType].sids" @on-change="radioCheckScope"
                                    size="large">
                            <Radio :label="item.id" v-for="(item,index) in selectedTree[currentScopeType].data"
                                   :style="{marginRight:'20px',marginTop:'20px'}">
                                {{item.name}}
                            </Radio>
                        </RadioGroup>
                    </div>
                    <div :style="{textAlign:'left'}" v-else>
                        <CheckboxGroup v-model="selectedTree[currentScopeType].sidsArr" @on-change="checkBoxCheckScope"
                                       size="large">
                            <Checkbox :label="item.id" v-for="(item,index) in selectedTree[currentScopeType].data"
                                      :style="{marginRight:'20px',marginTop:'20px' }">
                                {{item.name}}
                            </Checkbox>
                        </CheckboxGroup>
                    </div>
                    <!--    <p v-if="retArr.length === 0" :style="{fontSize:'18px',fontWeight:'bold'}">{{lang('noSelectDataText',language)}}</p>-->
                </Col>
            </Row>
            <Divider/>
            <Row>
                <Col span="3">
                    <Button type="default" @click="back">{{lang('previousStepText',language)}}</Button>
                </Col>
                <Col span="3">
                    <Button type="default" @click="next">{{lang('nextStepText',language)}}</Button>
                </Col>
                <Col span="3">
                    <Button type="primary" @click="confirm">{{lang('saveText',language)}}</Button>
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
    var _hmt = _hmt || [];
    (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?4537bce4a2128c98b476fa3bc3b18f86";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();

    import {lang} from "@/utils/language.js";
    import store from '@/store/index.js';
    import config from '@/utils/config.js';
    import {getScope} from '@/utils/net.js';

    export default {
        name: "SelectScope",
        store,
        data() {
            return {
                lang: lang,
                stateLang: '',
                scopeType: 's',
                currentScopeType: 's',
                keywords: '',
                radioSelect: '',
                selectedTree: {
                    s: {
                        scopeType: 's',
                        data: [],
                        sids: null,
                        sidsArr: [],
                        snameArr: []
                    },
                    c: {
                        scopeType: 'c',
                        data: [],
                        sids: null,
                        sidsArr: [],
                        snameArr: []
                    },
                    g: {
                        scopeType: 'g',
                        data: [],
                        sids: null,
                        sidsArr: [],
                        snameArr: []
                    },
                    u: {
                        scopeType: 'u',
                        data: [],
                        sids: null,
                        sidsArr: [],
                        snameArr: []
                    }
                },
                selectTreeRouter: {
                    s: ['s'],
                    c: ['s', 'c'],
                    g: ['g'],
                    u: ['s', 'c', 'u'],
                }
            }
        },
        mounted() {
            if (store.getters.getScope !== null) {
                this.scopeType = store.getters.getScope.scopeType;
                this.selectedTree = store.getters.getScope.selectedTree
            } else {
                this.changeScopeType(this.scopeType);
            }
            this.currentScopeType = this.scopeType;
            if(store.getters.getScope === null){
                if(store.getters.getUser.adminRole === 3){
                    this.scopeType = 'c';
                }
            }
        },
        methods: {
            getScopeData(scopeType, param) {
                let that = this;
                var retArr = []
                var path = config['selectScopeApiPath_' + scopeType];
                getScope({
                    context: that,
                    url: '/open/acct/' + path,
                    params: param,
                    onCallBack: function (retMap) {
                        var tempArr = retMap.list;
                        switch (scopeType) {
                            case 's':
                                for (var index in tempArr) {
                                    var item = {};
                                    item.name = tempArr[index].cname;
                                    item.id = tempArr[index].schoolId;
                                    retArr.push(item)
                                }
                                break;
                            case 'c':
                                for (var index in tempArr) {
                                    var item = {};
                                    item.name = tempArr[index].cname;
                                    item.id = tempArr[index].classId;
                                    retArr.push(item)
                                }
                                break;
                            case 'g':
                                for (var index in tempArr) {
                                    var item = {};
                                    item.name = tempArr[index].groupName;
                                    item.id = tempArr[index].groupId;
                                    retArr.push(item)
                                }
                                break;
                            case 'u':
                                for (var index in tempArr) {
                                    var item = {};
                                    item.name = tempArr[index].name;
                                    item.id = tempArr[index].userId;
                                    retArr.push(item)
                                }
                                break;
                        }
                        that.selectedTree[scopeType].data = retArr;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.readingDataLoading = false;
                    }
                })
            },

            searchSopeData(scopeType, param) {
                let that = this;
                var retArr = []
                var path = config['searchScopeApiPath_' + scopeType];
                getScope({
                    context: that,
                    url: '/open/acct/' + path,
                    params: param,
                    onCallBack: function (retMap) {
                        var tempArr = retMap.list;
                        switch (scopeType) {
                            case 's':
                                for (var index in tempArr) {
                                    var item = {};
                                    item.name = tempArr[index].cname;
                                    item.id = tempArr[index].schoolId;
                                    retArr.push(item)
                                }
                                break;
                            case 'c':
                                for (var index in tempArr) {
                                    var item = {};
                                    item.name = tempArr[index].cname;
                                    item.id = tempArr[index].classId;
                                    retArr.push(item)
                                }
                                break;
                            case 'g':
                                for (var index in tempArr) {
                                    var item = {};
                                    item.name = tempArr[index].groupName;
                                    item.id = tempArr[index].groupId;
                                    retArr.push(item)
                                }
                                break;
                            case 'u':
                                for (var index in tempArr) {
                                    var item = {};
                                    item.name = tempArr[index].name;
                                    item.id = tempArr[index].userId;
                                    retArr.push(item)
                                }
                                break;
                        }
                        that.selectedTree[scopeType].data = retArr;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.readingDataLoading = false;
                    }
                })
            },

            //clearSelectData
            clearSelectData() {
                this.selectedTree['s'].data = [];
                this.selectedTree['s'].sids = null;
                this.selectedTree['s'].sidsArr = [];
                this.selectedTree['s'].snameArr = [];

                this.selectedTree['c'].data = [];
                this.selectedTree['c'].sids = null;
                this.selectedTree['c'].sidsArr = [];
                this.selectedTree['c'].snameArr = [];

                this.selectedTree['g'].data = [];
                this.selectedTree['g'].sids = null;
                this.selectedTree['g'].sidsArr = [];
                this.selectedTree['g'].snameArr = [];

                this.selectedTree['u'].data = [];
                this.selectedTree['u'].sids = null;
                this.selectedTree['u'].sidsArr = [];
                this.selectedTree['u'].snameArr = [];
            },

            // 改变范围类型
            changeScopeType(type) {
                this.clearSelectData();
                if(type === 'g'){
                    this.currentScopeType = 'g';
                    this.scopeType = type;
                    this.getScopeData('g');
                }else{
                    this.currentScopeType = 's';
                    this.scopeType = type;
                    this.getScopeData('s');
                }
            },

            // 搜索
            search() {
                let obj = {};
                let i = 0
                let arr = this.selectTreeRouter[this.scopeType];
                for (let j = 0; j < arr.length; j++) {
                    if (arr[j] == this.currentScopeType) {
                        i = j;
                        break;
                    }
                }
                if (this.keywords.length > 0) {
                    obj.keywords = this.keywords
                    if (this.currentScopeType == 'c') {
                        obj.schoolId = this.selectedTree[arr[i - 1]].sids;
                    } else if (this.currentScopeType == 'u') {
                        obj.cgId = this.selectedTree[arr[i - 1]].sids;
                        obj.cg = 'c';
                    }
                    this.searchSopeData(this.currentScopeType, obj)
                } else {
                    if (this.currentScopeType == 'c') {
                        obj.schoolId = this.selectedTree[arr[i - 1]].sids;
                    } else if (this.currentScopeType == 'u') {
                        obj.cgId = this.selectedTree[arr[i - 1]].sids;
                        obj.cg = 'c';
                    }
                    this.getScopeData(this.currentScopeType,obj)
                }
            },

            changeCurrentScopeType(type, pre) {
                let arr = this.selectTreeRouter[this.scopeType];
                let i = 0;
                let sids = this.selectedTree[type].sids;
                let obj = {};
                let ok = false;
                for (let j = 0; j < arr.length; j++) {
                    if (arr[j] == type) {
                        i = j;
                        break;
                    }
                }
                if (pre) {
                    if (i > 0) {
                        type = arr[i - 1];
                        ok = true;
                        if(type == 'c'){
                            sids = this.selectedTree[arr[arr.indexOf(type)-1]].sids
                        }
                    }
                } else {
                    if (i < arr.length - 1) {
                        type = arr[i + 1];
                        ok = true;
                        this.selectedTree[type].sids = '';
                        this.selectedTree[type].sidsArr = [];
                        this.selectedTree[type].snameArr = [];
                    }
                }
                if (ok) {
                    if (type == 'c') {
                        obj.schoolId = sids;
                    } else if (type == 'u') {
                        obj.cg = 'c';
                        obj.cgId = sids;
                    }
                    this.getScopeData(type, obj)
                    this.currentScopeType = type;
                }
            },

            back() {
                this.changeCurrentScopeType(this.currentScopeType, true);
            },

            next() {
                this.changeCurrentScopeType(this.currentScopeType, false);
            },

            radioCheckScope(data) {
                let sData = this.selectedTree[this.currentScopeType].data;
                let sids = '';
                let sname = '';
                for (let i = 0; i < sData.length; i++) {
                    /*sData[i].select = false;*/
                    if (sData[i].id == data) {
                      /*  sData[i].select = true;*/
                        sids = data;
                        sname = sData[i].name;
                        break;
                    }
                }
                this.selectedTree[this.currentScopeType].data = sData;
                this.selectedTree[this.currentScopeType].sids = sids;
                this.selectedTree[this.currentScopeType].sidsArr = [data];
                this.selectedTree[this.currentScopeType].snameArr = [sname];
                if (sids != '') {
                    this.changeCurrentScopeType(this.currentScopeType, false);
                }
            },


            checkBoxCheckScope(data) {
                let sData = this.selectedTree[this.currentScopeType].data;
                let sids = '';
                let snameArr = [];
                for (let i = 0; i < sData.length; i++) {
                    sData[i].select = false;
                    for (let j = 0; j < data.length; j++) {
                        if (sData[i].id == data[j]) {
                            sData[i].select = true;
                            if (sids != '') {
                                sids = sids + ',';
                            }
                            sids = sids + data[j];
                            snameArr.push(sData[i].name)
                            break;
                        }
                    }
                }
                this.selectedTree[this.currentScopeType].data = sData;
                this.selectedTree[this.currentScopeType].sids = sids;
                this.selectedTree[this.currentScopeType].sidsArr = data;
                this.selectedTree[this.currentScopeType].snameArr = snameArr;
            },



            // 确认按钮
            confirm() {
                if (this.selectedTree[this.scopeType].sidsArr.length > 0) {
                    var scope = {};
                    scope.scope = this.selectedTree[this.scopeType].sids
                    scope.scopeType = this.scopeType
                    scope.selectedTree = this.selectedTree
                    store.commit('setScope', scope)
                    this.$Message.success(this.lang('selectSuccessTipText', this.language));
                } else {
                    this.$Message.warning(this.lang('noSelectTipText', this.language));
                }
            }
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },
            userInfo: function () {
                return store.getters.getUser;
            }
        },
        watch: {
            stateLang: function () {
            },
            keywords: function () {
                this.search()
            }
        },
    }
</script>

<style scoped>
    .scopeRadio {
        margin-left: 50px;
    }
</style>
